module.exports = __webpack_public_path__ + "static/media/cg.51ec77aa.svg";